/**
 * Detail Cards Carousel
 * Swiper-based horizontal carousel with parallax text animations
 */

class DetailCardsCarousel {
  constructor(container) {
    this.container = container;
    this.swiper = null;
    this.cursorArrow = null;
    this.breakpoint = 750;
    this.init();
  }

  isDesktop() {
    return window.innerWidth >= this.breakpoint;
  }

  init() {
    // Wait for Swiper to be available
    if (typeof Swiper === 'undefined') {
      setTimeout(() => this.init(), 100);
      return;
    }

    this.cacheElements();
    this.initSwiper();
    this.initCursorArrow();
  }

  cacheElements() {
    this.cursorArrow = this.container.querySelector('.detail-cards__cursor-arrow');
  }

  initSwiper() {
    const isDesktop = this.isDesktop();
    const slideCount = this.container.querySelectorAll('.swiper-slide').length;
    
    // Base configuration for mobile
    const config = {
      // Slide dimensions
      slidesPerView: 'auto',
      spaceBetween: 20,
      
      // Offset for proper spacing
      slidesOffsetBefore: 22,
      slidesOffsetAfter: 22,
      
      // Parallax effect
      parallax: true,
      speed: 400,
      
      // Behavior
      touchRatio: 1,
      touchAngle: 45,
      threshold: 5,
      
      // Performance
      passiveListeners: true,
      watchSlidesProgress: true,

      // Start at first slide (mobile)
      initialSlide: 0,
    };

    // Desktop-specific configuration
    if (isDesktop && slideCount >= 3) {
      Object.assign(config, {
        // Desktop: Start at first slide (index 0) for proper loop display
        initialSlide: 0,
        
        // Centered slides with peek effect
        centeredSlides: true,
        
        // Infinite loop in both directions
        loop: true,
        loopedSlides: slideCount,
        
        // Desktop spacing
        spaceBetween: 40,
        
        // Slide dimensions
        slidesPerView: 'auto',
      });
    }
    
    this.swiper = new Swiper(this.container, config);
  }

  initCursorArrow() {
    if (!this.isDesktop() || !this.cursorArrow || !this.swiper) return;

    const arrow = this.cursorArrow;
    const carousel = this.container;
    const svg = arrow.querySelector('svg');

    // Mouse move handler
    carousel.addEventListener('mousemove', (e) => {
      const rect = carousel.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      const centerX = rect.width / 2;

      // Position arrow at cursor (offset by half arrow size for centering)
      arrow.style.transform = `translate(${x - 32}px, ${y - 32}px)`;

      // Rotate based on which side of carousel
      if (x < centerX) {
        // Left side - rotate 180deg (point left)
        svg.style.transform = 'rotate(180deg)';
      } else {
        // Right side - no rotation (point right)
        svg.style.transform = 'rotate(0deg)';
      }
    });

    // Click handler
    carousel.addEventListener('click', (e) => {
      const rect = carousel.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const centerX = rect.width / 2;

      if (x < centerX) {
        // Left side - go to previous
        this.swiper.slidePrev();
      } else {
        // Right side - go to next
        this.swiper.slideNext();
      }
    });

    // Cursor style is set via CSS
  }

  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

/**
 * Initialize all detail cards carousels on the page
 */
document.addEventListener('DOMContentLoaded', () => {
  const carousels = document.querySelectorAll('.detail-cards__carousel');
  
  carousels.forEach(carousel => {
    new DetailCardsCarousel(carousel);
  });
});

